import { api } from './api';

// Define a service using a base URL and expected endpoints
export const entityParameterApi = api.injectEndpoints({
  reducerPath: 'entityParameterApi',
  tagTypes: ['EntityParameters', 'EntitiesParameters'],
  endpoints: (builder) => ({
    getEntityParameterValues: builder.query({
      query: (entityParameterTypeCode) => ({
        url: `/public/api/entities/parameters/values?entityParameterTypeCode=${entityParameterTypeCode}`,
        method: 'GET'
      }),
      providesTags: ['EntityParameters']
    }),
    getEntityParameterValuesMap: builder.query({
      queryFn: (entityParameterTypeCodes, _queryApi, _extraOptions, fetchWithBQ) => {
        const promises = entityParameterTypeCodes.map((code) =>
          fetchWithBQ(`/public/api/entities/parameters/values?entityParameterTypeCode=${code}`)
        );
        return Promise.all(promises).then((results) => ({
          data: new Map(
            results?.map((result, index) => [entityParameterTypeCodes[index], result.data])
          )
        }));
      },
      providesTags: ['EntitiesParameters']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEntityParameterValuesQuery, useGetEntityParameterValuesMapQuery } =
  entityParameterApi;
